import React from 'react';

import UserReminders from 'components/Reminders/UserReminders';
import RemindersErrorBoundary from 'components/Reminders/RemindersErrorBoundary';

const Dashboard = () => (
  <div>
    <RemindersErrorBoundary>
      <UserReminders />
    </RemindersErrorBoundary>
  </div>
);

export default Dashboard;
